import { Component, EventEmitter, Input, Output } from '@angular/core';
import {MatMenu, MatMenuItem, MatMenuTrigger} from "@angular/material/menu";
import {MatToolbarModule} from "@angular/material/toolbar";
import { MatIconModule } from '@angular/material/icon';
import { AuthService } from '../../../auth/services/auth.service';
import { LoggedUser } from '../../../auth/interfaces/logged-user';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-header',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatMenu,
    MatMenuItem,
    MatToolbarModule,
    MatMenuTrigger
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  constructor(private readonly authService: AuthService) {}

  @Input()
  loggedUser?: LoggedUser;

  @Output()
  toggleSidenav = new EventEmitter<void>();

  showFiller = false;
  async logout(){
    sessionStorage.removeItem('loggedUser');
    await this.authService.logout();
  }
}
